<template>
    <el-form-item :prop="id" :class="wrapperClass">
        <span class="page-anchor" :id="id"/>

        <div class="form-label">
            <h5>{{ title }}</h5>
            <small v-if="description">{{ description }}</small>
            <slot name="info"/>
        </div>

        <div class="switch-label">
            <el-switch active-color="#00a344" :disabled="disabled" v-model="text" @change="$emit('change', text)" />

            <label>
                <slot/>
            </label>

            <slot name="badge"/>
        </div>
    </el-form-item>
</template>

<script>
export default {
    model: {
        prop: 'value',
        event: 'change'
    },

    props: {
        id: {
            type: String,
            required: true
        },

        title: {
            type: String,
            required: true
        },

        value: {
            type: Boolean,
            required: true
        },

        description: {
            type: String,
            required: false
        },

        disabled: {
            type: Boolean,
            required: false,
            default: false
        },

        wrapperClass: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return {
            text: this.value
        }
    }
}
</script>
